import { ceilPowerOfTwo } from "three/src/math/MathUtils"

const actionOrbitSchema = [
  {
    type: 'select',
    label: 'Orbit center:',
    name: 'center',
    options: {},
    events: ['input'],
  },
  {
    type: 'select',
    label: 'Axis:',
    name: 'axis',
    options: {
      right: 'Right',
      up: 'Up',
      rear: 'Rear',
    },
    events: ['input'],
  },
  {
    type: 'checkbox',
    name: 'use_world_axis',
    label: 'If checked, axis are world space axis. Otherwise, local to object.',
    events: ['input'],
  },
  {
    type: 'select',
    label: 'Direction:',
    name: 'direction',
    options: {
      clockwise: 'Clockwise',
      counterclockwise: 'Counterclockwise',
    },
    events: ['input'],
  },
  {
    type: 'number',
    name: 'cycle_time',
    label: 'Cycle Time: (in seconds)',
    events: ['input'],
    help: 'Defines one 360° cycle duration.',
    min: '0',
    step: 1,
  },
  {
    type: 'number',
    name: 'duration',
    label: 'Duration: (in seconds)',
    events: ['input'],
    help: 'Defines the overwall animation duration. Set to -1 for infinite.',
    min: '-1',
    step: 1,
  },
  {
    type: 'number',
    name: 'radius',
    label: 'Orbit radius: (in meters)',
    events: ['input'],
    help: 'Defines the distance from the center to the object',
    min: '0',
    step: 0.1,
  },
  {
    type: 'checkbox',
    name: 'align_to_path',
    label: 'Align to path',
    events: ['input'],
  },
  {
    type: 'checkbox',
    name: 'rewind_when_done',
    label: 'Rewind when done',
    events: ['input'],
  },
]
const actionOrbitValue = {
  type: 'action_spin',
  center: '',
  axis: 'up',
  use_world_axis: true,
  duration: 10,
  direction: 'clockwise',
  cycle_time: 3,
  radius: 2,
  align_to_path: true,
  rewind_when_done: false,

}
export { actionOrbitSchema, actionOrbitValue }
